/* 🤖 this file was generated by svg-to-ts */
export const iconEdit: {
  name: 'edit';
  data: string;
} = {
  name: 'edit',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M3.824 11.535l-.588 1.176 1.176-.588L13.8 2.901a.532.532 0 00-.759-.747l-9.216 9.381zM1 15.947A1 1 0 01.105 14.5l2-4c.047-.094.11-.179.182-.254l9.333-9.5A2.536 2.536 0 0115.207.74a2.536 2.536 0 010 3.581L5.701 13.66c-.075.073-.16.135-.254.182l-4 2a1 1 0 01-.447.105z"/></svg>`,
};
